import { Environment } from '@s2a/ng-common';

export const environment: Environment = {
  production: false,
  baseUrl: 'https://api.share2act-test.io/v1/',
  iconUrl: 'https://icons.share2act-test.io/v1/',
};
